import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "../../mui";
import Permissions from "./Permissions";
import ParentOrganization from "./ParentOrganization";
const Features = ({}) => (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Permissions, {}) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(ParentOrganization, {}) })] }));
export default Features;
